import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setReloadTaskList, setSelectAll, setSelectedRows } from './TasksSlice';
import './DateRangePicker.css';
import { showAlert } from '../../components/PerinHealthAlertSlice';
import useAxios from '../../services/AxiosConfig';
import styles from '../ManagementPages.module.css';
import taskStyles from './Tasks.module.css';

const DateTimePicker = ({ show, onClose }) => {
  const dispatch = useDispatch();
  const { selectedItem } = useSelector((state) => state.taskListPanel);
  const axiosConfig = useSelector((state) => state.axiosConfig);
  const axios = useAxios(axiosConfig.envURL);

  const [dueDate, setDueDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');

  useEffect(() => {
    if (selectedItem && selectedItem.dueDate) {
      setDueDate(new Date(selectedItem.dueDate));
      const time = new Date(selectedItem.dueDate).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
      setSelectedTime(time);
    } else {
      setDueDate(null);
      setSelectedTime('');
    }
  }, [selectedItem]);

  const handleDateChange = (e) => {
    const selectedDate = e.target.value; 
    const [year, month, day] = selectedDate.split('-'); 
    const newDueDate = new Date(year, month - 1, day);
    setDueDate(newDueDate);
  };
  

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const handleSave = async () => {
    if (dueDate && selectedTime) {
      const [hour, minute] = selectedTime.split(':');
      const updatedDueDate = new Date(dueDate);
      updatedDueDate.setHours(parseInt(hour, 10)); 
      updatedDueDate.setMinutes(parseInt(minute, 10));
      updatedDueDate.setSeconds(0); 

      const dueDateString = updatedDueDate.toISOString();

      const payload = {
        accountId: selectedItem.accountId,
        staffTaskId: selectedItem.staffTaskId,
        dueDate: dueDateString,
      };

      try {
        const response = await axios.post('/staffTasks/updateDueDate', payload);
        if (response.data.data) {
          dispatch(setSelectedRows([]));
          dispatch(setSelectAll(false));
          onClose();
          dispatch(setReloadTaskList(true));
          dispatch(
            showAlert({
              header: "Success",
              message: "Successfully Set Reminder",
              type: 'success',
            })
          );
        }
      } catch (err) {
        onClose();
        dispatch(
          showAlert({
            header: "Error",
            message: `Could not Update Due Date: ${err}`,
            type: 'danger',
          })
        );
      }
    }
  };

  const generateTimeOptions = () => {
    const times = [];
    for (let hour = 7; hour < 20; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = new Date();
        time.setHours(hour);
        time.setMinutes(minute);
        const formattedTime = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        times.push(formattedTime);
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();


  return (
    <Modal
      show={show}
      onHide={onClose}
      size="md"
      backdrop='static'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Reminder</Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <Form.Group style={{ width: '100%' }}>
          <Form.Label>Date & Time:</Form.Label>
          <div className={styles["styled-input-container"]} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <input
                id="admitDate"
                type="date" 
                min={new Date().toISOString().split('T')[0]}
                style={{ width: '100%' }}
                value={dueDate ? dueDate.toISOString().substr(0, 10) : ''}
                onChange={handleDateChange}
              />
              <label className={styles['filled']}>Date*</label>
            </div>
            <div style={{ position: 'relative' }}>
              <span className="floating-label">Time</span>
              <select
                style={{
                  width: '100%' ,
                  maxHeight: '300px',
                  overflowY: 'auto'
                }}
                className={styles["styled-input-select"]}
                value={selectedTime}
                onChange={handleTimeChange}
              >
                <option value="">Select</option>
                {timeOptions.map((time, index) => (
                  <option key={index} value={time}>
                    {time}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className={taskStyles.ModelFooter}>
        <Button className={taskStyles.BackButton} onClick={onClose}>
          Cancel
        </Button>
        <Button className={taskStyles.NextButton} onClick={handleSave} >
          Set Reminder
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DateTimePicker;
